export default ['JsonRPCService', (JsonRPCService) => {
    const operationNamesMessageKeys = {
        specialistacceptedwork: 'servicerequest.services.ServiceRequestService.action.Accept Work',
        specialistresumedwork: 'servicerequest.services.ServiceRequestService.action.Resume Work',
        specialistdeclined: 'servicerequest.services.ServiceRequestService.action.Decline Work',
        specialistwaiting: 'servicerequest.services.ServiceRequestService.action.Report : Work Blocked',
        specialistcompletedwork: 'servicerequest.services.ServiceRequestService.action.Complete Work',
        specialistcanceled: 'servicerequest.services.ServiceRequestService.action.Cancel Work',
        addinvoice: 'servicerequest.services.ServiceRequestService.action.Add Invoice'
    };

    const summaryOperationNamesMessageKeys = {
        specialistacceptedwork: 'servicerequest.services.ServiceRequestService.action.Agree',
        specialistresumedwork: 'servicerequest.services.ServiceRequestService.action.Resume',
        specialistdeclined: 'servicerequest.services.ServiceRequestService.action.Decline',
        specialistwaiting: 'servicerequest.services.ServiceRequestService.action.Report : Work Blocked',
        specialistcompletedwork: 'servicerequest.services.ServiceRequestService.action.Finish',
        specialistcanceled: 'servicerequest.services.ServiceRequestService.action.Cancel',
        addinvoice: 'servicerequest.services.ServiceRequestService.action.Add Invoice'
    };

    /* const serviceRequestStatusKeys = {
     onlyactive: 'servicerequest.services.ServiceRequestService.action.Active',
     onlycanceledanddeclined: 'servicerequest.services.ServiceRequestService.action.Canceled',
     onlycompletewaitingforinvoice: 'servicerequest.services.ServiceRequestService.action.Waiting for Invoice',
     onlyinactive: 'servicerequest.services.ServiceRequestService.action.Inactive',
     onlyoverdue: 'servicerequest.services.ServiceRequestService.action.Overdue',
     onlyunpaidinvoices: 'servicerequest.services.ServiceRequestService.action.Unpaid Invoices',
     onlywaiting: 'servicerequest.services.ServiceRequestService.action.Waiting',
     onlywaitingforquote: 'servicerequest.services.ServiceRequestService.action.Waiting for Quote'
     };*/

    return {
        getServiceRequestsForVendor: () => {
            return JsonRPCService.send('cc', 'servicerequest/servicerequest', 'getServiceRequestsForVendor', []);
        },

        getMessagesForSpecialist: () => {
            return JsonRPCService.send('cc', 'servicerequest/servicerequest', 'getMessagesForSpecialist', []);
        },

        getServiceRequestDetails: (serviceRequestNumber) => {
            return JsonRPCService.send('cc', 'servicerequest/servicerequest', 'getServiceRequestDetails', [serviceRequestNumber]);
        },

        createMessage: (serviceRequestNumber, messageDTO) => {
            return JsonRPCService.send('cc', 'servicerequest/servicerequest', 'createMessage', [serviceRequestNumber, messageDTO]);
        },

        addOrReplaceQuote: (publicID, quoteDTO) => {
            return JsonRPCService.send('cc', 'servicerequest/servicerequest', 'addOrReplaceQuote', [publicID, quoteDTO]);
        },

        addInvoice: (publicID, invoiceDTO) => {
            return JsonRPCService.send('cc', 'servicerequest/servicerequest', 'addInvoice', [publicID, invoiceDTO]);
        },

        withdrawInvoice: (invoiceWithdrawalDTO) => {
            return JsonRPCService.send('cc', 'servicerequest/servicerequest', 'withdrawInvoice', [invoiceWithdrawalDTO]);
        },

        acceptWork: (acceptWorkDTO) => {
            return JsonRPCService.send('cc', 'servicerequest/servicerequest', 'acceptWork', [acceptWorkDTO]);
        },

        declineWork: (serviceRequestAction) => {
            return JsonRPCService.send('cc', 'servicerequest/servicerequest', 'declineWork', [serviceRequestAction]);
        },

        cancelServiceRequest: (serviceRequestAction) => {
            return JsonRPCService.send('cc', 'servicerequest/servicerequest', 'cancelServiceRequest', [serviceRequestAction]);
        },

        reportBlocked: (serviceRequestAction) => {
            return JsonRPCService.send('cc', 'servicerequest/servicerequest', 'reportBlocked', [serviceRequestAction]);
        },

        reportDelay: (serviceRequestReportDelay) => {
            return JsonRPCService.send('cc', 'servicerequest/servicerequest', 'reportDelay', [serviceRequestReportDelay]);
        },

        completeWork: (serviceRequestNumber) => {
            return JsonRPCService.send('cc', 'servicerequest/servicerequest', 'completeWork', [serviceRequestNumber]);
        },

        resumeWork: (serviceRequestNumber) => {
            return JsonRPCService.send('cc', 'servicerequest/servicerequest', 'resumeWork', [serviceRequestNumber]);
        },

        updateReferenceNumber: (serviceRequestAction) => {
            return JsonRPCService.send('cc', 'servicerequest/servicerequest', 'updateReferenceNumber', [serviceRequestAction]);
        },

        getInvoicesForSpecialist: () => {
            return JsonRPCService.send('cc', 'servicerequest/servicerequest', 'getInvoicesForSpecialist', []);
        },

        getOperationNameMessageKey: (operation) => {
            const opName = operationNamesMessageKeys[operation.code];
            return opName || operation.displayKey;
        },

        getSummaryOperationNameMessageKey: (operation) => {
            const opName = summaryOperationNamesMessageKeys[operation.code];
            return opName || operation.displayKey;
        },

        closeServiceRequest_EY: (serviceRequestAction) => {
            return JsonRPCService.send('cc', 'servicerequest/servicerequest', 'closeServiceRequest_EY', [serviceRequestAction]);
        },
    };
}];